module.exports = __webpack_public_path__ + "static/media/tipger.dd2ed215.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/tipger.png
// module id = 447
// module chunks = 0